// extracted by mini-css-extract-plugin
export default {"recos":"f9-z","productCardOverride":"g9-z","rowHasBadge":"h9-z"};